import './contact-section.component.scss'
import { createMap } from '../../application/core/map-service'

const mapElement = document.querySelector('.contact-section-map .map-container')
const section = document.querySelector('section.contact-section')

if (mapElement) {
  const zoom = 11
  const mapItem = document.querySelector('[data-location-url]')
  const marker = document.querySelector('[data-pin-icon-url]')
  const [lat, lng] = mapItem.dataset.location.split(',')
  const locations = [
    {
      lat: parseFloat(lat || 0),
      lng: parseFloat(lng || 0),
      name: 'Ninja De-Icer',
      url: mapItem.dataset.locationUrl,
      marker: marker.dataset.pinIconUrl
    }
  ]
  createMap(mapElement, locations, zoom, false)
}

async function initFormDependecies() {
  import(/* webpackChunkName: 'imask' */ 'imask').then(({ default: IMask }) => {
    const phoneInput = document.querySelector('input#phone')
    if (phoneInput) {
      IMask(phoneInput, {
        mask: '000-000-0000'
      })
    }
  })
  // import(/* webpackChunkName: 'validate' */ '../../application/core/validate')
}
if (section) {
  initFormDependecies()
}

function rebuildSelect() {
  const select = document.querySelector('.template-page-contact .contact-section-form select')
  if (select) {
    const options = select.querySelectorAll('option')
    options[0].disabled = true
    options[0].innerHTML = 'Choose the Product'
    options[0].hidden = true
    // Array.from(options).forEach(option => {
    //   option.style.color = '#212b34'
    // })
  }
}
rebuildSelect()
